import { registerTheme } from '../../theme';
registerTheme('funnel', {});
//# sourceMappingURL=theme.js.map